const React = require("react");
const { useStaticQuery, graphql } = require("gatsby");

module.exports = function useNewsCategories() {
  const { allTaxonomyTermNewsCategories, allNodeArticle } = useStaticQuery(
    graphql`query AllNewsCategories {
      allNodeArticle(
        filter: {fields: {pagePath: {ne: null}}, status: {eq: true}}
      ) {
        distinct(field: {relationships: {field_news_categories: {name: SELECT}}})
      }
      allTaxonomyTermNewsCategories(sort: {name: ASC}) {
        edges {
          node {
            id: drupal_internal__tid
            name
          }
        }
      }
    }`
  );

  // A list of the news categories used on the current site
  const localNewsCategories = allNodeArticle.distinct;
  // Remove news categories that are not in localNewsCategories
  const filteredNewsCategories = allTaxonomyTermNewsCategories.edges.filter((item) => {
    return localNewsCategories.indexOf(item.node.name) !== -1
  });

  return filteredNewsCategories.map((edge) => ({
    ...edge.node,
    id: `${edge.node.id}`,
  }));
};